import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function Terminos() {
  return <LegalLayout title="Términos y Condiciones" data-id="element-344">
      <div className="space-y-6 text-muted-foreground font-light leading-relaxed" data-id="element-345">
        <p data-id="element-346">Última actualización: Mayo 2026</p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-347">
          1. Naturaleza del Producto
        </h2>
        <p data-id="element-348">
          Todos los productos ofrecidos en Glow Up Femenino son de naturaleza
          100% digital. Al realizar una compra, no se enviará ningún artículo
          físico a tu domicilio. El acceso a los materiales se entrega de forma
          electrónica inmediatamente después de confirmar el pago.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-349">
          2. Uso Personal
        </h2>
        <p data-id="element-350">
          El contenido de "Glow Up Femenino en 30 Días" y todos sus bonos
          asociados están diseñados estrictamente para tu uso personal e
          individual. Al adquirir esta colección, se te otorga una licencia de
          uso personal, no exclusiva y no transferible.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-351">
          3. Propiedad Intelectual y Prohibiciones
        </h2>
        <p data-id="element-352">
          Todo el contenido, diseño, textos y metodologías son propiedad
          intelectual de Glow Up Femenino. Queda estrictamente prohibida la
          reventa, reproducción, distribución, copia o modificación de cualquier
          parte de estos materiales digitales sin nuestro consentimiento expreso
          por escrito.
        </p>

        <h2 className="text-2xl font-serif text-foreground mt-10 mb-4" data-id="element-353">
          4. Acceso al Contenido
        </h2>
        <p data-id="element-354">
          Es tu responsabilidad descargar y guardar los archivos digitales en
          tus dispositivos personales. Te recomendamos hacer una copia de
          seguridad de tus archivos una vez descargados.
        </p>
      </div>
    </LegalLayout>;
}